module.exports = __webpack_public_path__ + "static/media/pmt_enter-payments-adjustments-entry.8c569f3e.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/pmt_enter-payments-adjustments-entry.md
// module id = 1104
// module chunks = 0